import type { ReactNode } from 'react';

export function FormRow({ label, hint, htmlFor, required, children }: { label: string; hint?: ReactNode; htmlFor?: string; required?: boolean; children: ReactNode }) {
  return (
    <div className="form-row">
      <label className="form-row__label" htmlFor={htmlFor}>
        {label}
        {required ? <span className="req">*</span> : null}
      </label>
      <div>
        {children}
        {hint ? <div className="form-row__hint">{hint}</div> : null}
      </div>
    </div>
  );
}

export function FormActions({ children }: { children: ReactNode }) {
  return <div className="form-actions">{children}</div>;
}

export function Toggle({ checked, onChange, label, disabled }: { checked: boolean; onChange: (v: boolean) => void; label?: string; disabled?: boolean }) {
  return (
    <label className="toggle">
      <input type="checkbox" role="switch" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
      {label ? <span>{label}</span> : null}
    </label>
  );
}

export function Tabs<T extends string>({ tabs, active, onChange }: { tabs: { key: T; label: string; count?: number }[]; active: T; onChange: (key: T) => void }) {
  return (
    <div className="tabs" role="tablist">
      {tabs.map((t) => (
        <button key={t.key} type="button" role="tab" aria-selected={active === t.key} className={`tab${active === t.key ? ' tab--active' : ''}`} onClick={() => onChange(t.key)}>
          {t.label}
          {t.count !== undefined ? <span className="tab__count">{t.count}</span> : null}
        </button>
      ))}
    </div>
  );
}

export function TagsInput({ value, onChange, disabled }: { value: string[]; onChange: (tags: string[]) => void; disabled?: boolean }) {
  return (
    <input
      className="input"
      value={value.join(', ')}
      disabled={disabled}
      placeholder="comma, separated, tags"
      onChange={(e) =>
        onChange(
          e.target.value
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean),
        )
      }
    />
  );
}
